import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SearchByPlanName } from '../../data/reportsData';
import {
  formatDate,
  getNewParameters,
  getParameters,
  downloadBlobXLSFile,
  makeDateFromToday,
  breakStringIntoLines,
} from '../../lib/helper';
import {
  reportListingItemsSelector,
  setAllPlanSalesListing,
} from '../../redux/reports';
import { getPlanReportListing, getPlanReportListingExportFile } from '../../Services/reportsApis';
import AllFilters from '../Order/AllFilters';
import MatTable from '../Tables/MatTable';


const getDefaultParams = () => {
  return {
    planCategory: SearchByPlanName[0]?.value || '',
  };
};

const column = [
  {
    label: 'Order ID',
    id: 'order_id',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
  {
    label: 'Invoice ID',
    id: 'invoice_no',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
  {
    label: 'Price',
    id: 'initial_price',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
  {
    label: 'Order Created On',
    id: 'created_on',
    format: (value) => (value ? new Date(value).toLocaleDateString() : 'N/A'),
  },
  {
    label: 'Client Name',
    id: 'client_name',
    format: (columnData) => (
      <Typography variant="span" style={{ display: 'inline-block', maxWidth: 300, width: 'max-content' }}>
        {columnData ? breakStringIntoLines(columnData, 30) : 'N/A'}
      </Typography>
    ),
  },
  {
    label: 'Company Name',
    id: 'company_name',
    format: (columnData) => (
      <Typography variant="span" style={{ display: 'inline-block', maxWidth: 300, width: 'max-content' }}>
        {columnData ? breakStringIntoLines(columnData, 20) : 'N/A'}
      </Typography>
    ),
  },
  {
    label: 'Email',
    id: 'email',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
  {
    label: 'Plan Name',
    id: 'plan_name',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
  {
    label: 'Download Info',
    id: 'download_info',
    format: (columnData) => (
      <span style={{ display: 'inline-block' }}>
        <span style={{ display: 'inline-block', whiteSpace: 'nowrap', marginRight: '10px' }}>
          <Typography variant="span" style={{ fontWeight: 600 }}>
            Total Download:
          </Typography>{' '}
          {columnData?.total_downloads}
        </span>
        <span style={{ display: 'inline-block', whiteSpace: 'nowrap', marginRight: '10px' }}>
          <Typography variant="span" style={{ fontWeight: 600 }}>
            Downloaded:
          </Typography>{' '}
          {columnData?.downloads_used}
        </span>
        <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
          <Typography variant="span" style={{ fontWeight: 600 }}>
            Remaining Download:
          </Typography>{' '}
          {columnData?.remaining_downloads}
        </span>
      </span>
    ),
  },
  {
    label: 'Active Days',
    id: 'active_days',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
  {
    label: 'Usage Ratio',
    id: 'usage_ratio',
    format: (columnData) => (
      <Typography variant="span" style={{ whiteSpace: 'nowrap' }}>
        {columnData}
      </Typography>
    ),
  },
];

function PlanSaleReport() {
  const [initialParams] = useState(() => {
    const defaults = getDefaultParams();
    const paramsFromUrl = getParameters();
    return { ...defaults, ...paramsFromUrl };
  });
  const [tableListing, setTableListing] = useState([]);
  const { loading, planSalesReport } = useSelector(reportListingItemsSelector);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [limit, setLimit] = useState(20);
  const [expLoading, setExpLoading] = useState(false);
  
 const [allParams, setAllParams] = useState(initialParams);
  const [filtersArray, setFiltersArray] = useState([
    {
      label: 'From Date',
      id: 'from',
      type: 'input',
      value: makeDateFromToday(10),
      props: { type: 'date' },
      onChange: (e, index) => {
        setFiltersArray((prevState) => {
          const newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      isVisible: true,
    },
    {
      label: 'To Date',
      id: 'to',
      type: 'input',
      value: new Date().toISOString().split('T')[0],
      props: { type: 'date' },
      onChange: (e, index) => {
        setFiltersArray((prevState) => {
          const newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      isVisible: true,
    },
    {
      label: 'Plan Category',
      id: 'planCategory',
      type: 'select',
      value: '',
      dataArr: SearchByPlanName,
      onChange: (e, index) => {
        setFiltersArray((prevState) => {
          const newState = [...prevState];
          newState[index].value = e.target.value;
          return newState;
        });
      },
      style: {},
      props: {},
      isVisible: true,
      rowFlexible: true,
      row: 3,
    },
     {
          label: 'Search Text',
          id: 'search',
          type: 'input',
          linkedWith: null,
          value: '',
          onChange: (e, index, value) => {
            setFiltersArray((prevState) => {
              let newState = [...prevState];
              newState[index].value = e.target.value;
              return newState;
            });
          },
          style: {},
          dataArr: [],
          props: {},
          isVisible: true,
        },
  ]);

  const handleFilter = (data, allDatavalues, dataWithValue) => {
    const params = { ...getDefaultParams(), page: 1, ...dataWithValue };
    setAllParams(params);
    getOrderListing(params);
  };

const getExportFile = async (params = {}, b, prepop) => {
  try {
    setExpLoading(true);
    const exportFilters = { ...allParams, ...prepop };

    const apiPayload = {
      ...exportFilters,
      isExport: true,
    };
    if (exportFilters.from) {
      apiPayload.startDate =
        formatDate(exportFilters.from, 'yyyy-mm-dd') + ' 00:00:00';
    }
    if (exportFilters.to) {
      apiPayload.endDate =
        formatDate(exportFilters.to, 'yyyy-mm-dd') + ' 23:59:59';
    }

    delete apiPayload.page;
    delete apiPayload.limit;
    delete apiPayload.tab;
    delete apiPayload.from;
    delete apiPayload.to;
    if (apiPayload?.startDate && apiPayload?.endDate) {
      let resp = await getPlanReportListingExportFile(apiPayload);
      if (resp?.status) {
        downloadBlobXLSFile(resp.data, `PlanSalesReport`);
      } else {
        toast.error('To and From date required!');
      }
      setExpLoading(false);
    } else {
      toast.error('To and From date required!');
    }
  } catch (e) {
    console.log(e);
    setExpLoading(false);
  }
};
  const handleClear = () => {
    const defaultParams = getDefaultParams();
    setAllParams(defaultParams);
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[0].isVisible = true;
          newState[1].isVisible = true;
          newState[3].isVisible = true;
          newState[0].value = '';
          newState[1].value = '';
          newState[3].value = '';
      newState[2].value = defaultParams?.planCategory;
      return newState;
    });
    getOrderListing({ ...defaultParams, page: 1, from: '', to: '', search: ''  });
};

  useEffect(() => {
    if (planSalesReport && Array.isArray(planSalesReport.items?.report)) {
      const transformedReport = planSalesReport.items.report.map(item => ({
        ...item,
        download_info: {
          total_downloads: item.total_downloads,
          downloads_used: item.downloads_used,
          remaining_downloads: item.remaining_downloads,
        }
      }));
      setTableListing(transformedReport);
    } else {
      setTableListing([]);
    }
  }, [planSalesReport]);


  useEffect(() => {
    getOrderListing();
    return () => {
      dispatch(setAllPlanSalesListing());
    };
  }, []);

  const getOrderListing = async (params = {}) => {
    const combinedParams = {
      page: String(page),
      limit: String(limit),
      ...allParams,
      ...params,
    };
    if (!combinedParams.from && !combinedParams.to) {
        if (filtersArray[0]?.value && filtersArray[1]?.value) {
            combinedParams.from = filtersArray[0].value;
            combinedParams.to = filtersArray[1].value;
        }
    }
    const { from, to, ...rest } = combinedParams;

    const payload = {
      ...rest,
      page: String(combinedParams.page),
      limit: String(combinedParams.limit),
    };

    if (from) {
      payload.startDate = formatDate(from, 'yyyy-mm-dd') + ' 00:00:00';
    }
    if (to) {
      payload.endDate = formatDate(to, 'yyyy-mm-dd') + ' 23:59:59';
    }

    dispatch(getPlanReportListing(payload));
    setPage(Number(payload.page));
    if (payload.limit) {
      setLimit(Number(payload.limit));
    }
  };
  
  useEffect(() => {
    let data = getNewParameters(allParams);
    if (data?.search !== window.location.search) {
      navigate(data.newUrl, { replace: true });
      if (data?.parameters?.page) {
        setPage(Number(data?.parameters?.page))
      }
    }
  }, [allParams, navigate]);

  return (
    <>
      <MatTable
        loading={planSalesReport?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        onApplyFilter={(data = {}) => {
                  getListing({
                    page: String(1),
                    start_date: '',
                    end_date: '',
                    ...getObjectSubset(data, 'start_date', 'end_date'),
                  });
                  if (Object.keys(data).length > 0) {
                    setAllParams({
                      ...allParams,
                      page: String(1),
                      ...getObjectSubset(data, 'start_date', 'end_date'),
                    });
                  } else {
                    setAllParams({
                      page: String(1),
                    });
                  }
                }}
        page={page}
        perPage={limit}
        total={planSalesReport?.items?.totalCount || 0}
        setPage={setPage}
        showPageLimit={true}
        pageLimitArray={[20, 50, 100]}
        handleChangePageLimit={(e) => {
          // setLimit(e.target.value);
          const newLimit = Number(e.target.value);
          const newParams = {
            ...allParams,
            page: String('1'),
            limit: Number(newLimit),
          };
          setAllParams(newParams);
          getOrderListing(newParams);
        }}
        handlePageChange={(newPage) => {
          const newParams = { ...allParams, page: String(newPage) };
          setAllParams(newParams);
          getOrderListing(newParams);
        }}
        toolbarEnable={true}
        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
            hasDownloadExcelButton={true}
            handleDownloadExcel={getExportFile}
          />
        )}
        pagination={true}
        filtersUrlData={allParams || {}}
        disableSearch
      />
    </>
  );
}

export default PlanSaleReport;